import Vue from 'vue';

Vue.component('DocumentsIndexComponent', require('./components/DocumentsIndexComponent').default);
Vue.component('DocumentsGetComponent', require('./components/DocumentsGetComponent').default);
